import React from 'react'
import type { ProfileColumnDef } from './types'
import { PROFILE_TABLE_VARIANT_STYLES } from './variantStyles'

interface ProfileTableDragGhostProps {
    activeColumnItem: ProfileColumnDef<string>
    width: number
    uiVariant?: keyof typeof PROFILE_TABLE_VARIANT_STYLES
}

/**
 * Drag overlay ghost shown while the user drags a column header.
 *
 * Floating card with 9 placeholder rows. Colours are pure Tailwind dark-mode
 * variants — no runtime `isDark` branching, no import from a pages-level
 * theme hook (see `calm-spinning-turing.md` Phase 1 — "kill the
 * `useDashboardTheme` leak").
 */
export const ProfileTableDragGhost: React.FC<ProfileTableDragGhostProps> = ({ activeColumnItem, width, uiVariant = 'default' }) => {
    const styles = PROFILE_TABLE_VARIANT_STYLES[uiVariant]
    return (
        <div
            className={styles.dragGhost.container}
            style={{
                width: `${width}px`,
                minHeight: '240px',
                maxHeight: 'min(66vh, 520px)',
            }}
        >
            <div className={styles.dragGhost.header}>
                <span className={styles.dragGhost.label}>{activeColumnItem.label}</span>
            </div>
            <div className="flex flex-col gap-[3px] px-1.5 py-1">
                {Array.from({ length: 9 }).map((_, rowIndex) => (
                    <div key={`ghost-row-${rowIndex}`} className={styles.dragGhost.row} />
                ))}
            </div>
        </div>
    )
}
